<template>
  <v-dialog max-width="500" :value="value" @input="$emit('input', $event)">
    <v-card class="tags-list-vertical">
      <h3 class="pb-2">
        Toutes les étiquettes
      </h3>
      <ScrollBar
        max-height="400px"
        class="tags-list-vertical__scrollbar"
      >
        <div v-for="tag in tags" :key="tag.text">
          <Tag class="tags-list-vertical__tag" :tag="tag" />
        </div>
      </ScrollBar>
    </v-card>
  </v-dialog>
</template>

<script>
import ScrollBar from '@/shared/components/scrollbar/ScrollBar';
import Tag from './Tag';

export default {
  name: 'TagsListVertical',
  components: {
    Tag,
    ScrollBar,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    tags: {
      type: Array,
      default: undefined,
    },
  },
};
</script>

<style scope>
.tags-list-vertical {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: white;
  padding: 16px;
}
.tags-list-vertical__scrollbar {
  padding: 4px;
  border: 1px solid #E0E0E0;
  background-color: #F6F5FA;
  border-radius: 4px;
}
.tags-list-vertical__tag {
  margin: 4px;
}
</style>
